// Zones réservées à des lots ultérieurs : page d'attente honnête, sans contenu simulé.
import { EtatVide, LienBouton } from '@eec/ui';
import { Construction } from 'lucide-react';
import { useEffect } from 'react';
import styles from './acces/acces.module.css';
import { LogoComplet } from './acces/Logo';

export function PageAttente({ espace, lot, description }: { espace: string; lot: string; description: string }) {
  useEffect(() => {
    document.title = `${espace} - Eau Énergie Connect`;
  }, [espace]);
  return (
    <div className={styles.page}>
      <LogoComplet />
      <main className={`${styles.carte} ${styles.large}`} id="contenu-principal">
        <p className="cc-etiquette">{espace}</p>
        <h1>{espace}</h1>
        <EtatVide titre={`Disponible au lot ${lot}`} icone={Construction} niveau={2}>
          <p>{description}</p>
        </EtatVide>
        <LienBouton href="/" variante="secondaire">
          Aller à l&apos;espace Administration
        </LienBouton>
      </main>
    </div>
  );
}

export function PageIntrouvable() {
  useEffect(() => {
    document.title = 'Page introuvable - Eau Énergie Connect';
  }, []);
  return (
    <EtatVide titre="Page introuvable" niveau={2} action={<LienBouton href="/">Revenir au tableau de bord</LienBouton>}>
      <p>L&apos;adresse demandée ne correspond à aucune page de l&apos;espace Administration.</p>
    </EtatVide>
  );
}
